/**
 * description: 公用的选择通讯录的弹框
 * created by liu jinming
 * created on 2018.01.08
 */
"use strict";
angular.module('mailListMoudle', []).controller('mailListCtrl', ['$scope', '$modalInstance', 'trsHttpService', 'commandService', '$timeout', 'modalDialog', 'arr', 'globleParamsSet',
    function($scope, $modalInstance, trsHttpService, commandService, $timeout, modalDialog, arr, globleParamsSet) {
        initStatus();
        initData();

        /** [initData description] 初始化数据 */
        function initData() {
            init(); //初始化集团树的数据
            $scope.data.selectedPerson = arr === "" ? [] : arr;
        }
        /** [initStatus description]初始化你状态 */
        function initStatus() {
            $scope.status = {
                searchWord: '', //内部的人员名单过滤关键词
                searcKeyhWord: '', //整个树getSuggestions的关键词
            };
            $scope.data = {
                selectedPerson: []
            };
        }
        /** [getSuggestions description]快速查询列表内容 */
        $scope.getSuggestions = function(viewValue) {
            if (viewValue !== '') {
                var searchUsers = {
                    serviceid: "mlf_extuser",
                    methodname: "searchUserOrDept",
                    Name: viewValue
                };
                if ($scope.isRequest) {
                    $scope.isRequest = false;
                    return [];
                } else {
                    return trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), searchUsers, "get").then(function(data) {
                        var i = data.length - 1;
                        while (i >= 0) {
                            if (data[i].TYPE === "201") {
                                data.splice(i, 1);
                            }
                            i--;
                        }
                        return data;
                    });
                }
            }
        };
        $scope.$watch('status.searcKeyhWord', function(newValue, oldValue) {
            if (angular.isObject(newValue)) {
                $scope.isRequest = true;
                $scope.status.searcKeyhWord = newValue.USERNAME;
                var existence = false;
                for (var i in $scope.data.selectedPerson) {
                    var item = $scope.data.selectedPerson[i];
                    if (item === newValue.USERNAME) {
                        existence = true;
                    }
                }
                if (!existence) {
                    $scope.data.selectedPerson.push({ name: newValue.USERNAME, id: newValue.ID });
                }
            }
        });
        /** [close description] 关闭弹窗 */
        $scope.close = function() {
            $modalInstance.dismiss();
        };
        /** [confirm description] 确定完成选择 */
        $scope.confirm = function() {
            $modalInstance.close($scope.data.selectedPerson);
        };
        /** [myFilter description] 过滤器 通过过滤器删选出输入框搜索的数据 */
        $scope.myFilter = function(expected, actual) {
            var flag = true;
            if ($scope.status.searchWord !== "" && angular.isDefined($scope.status.searchWord)) {
                flag = expected.TRUENAME.indexOf($scope.status.searchWord) >= 0 ? true : false;
            }
            return flag;
        };
        /** [chooseRangeUserName description]选择可见范围用户 */
        $scope.chooseUserName = function(type, user) {
            if (type == "toChoose1") {
                angular.forEach($scope.rangeData, function(data, index, array) {
                    $scope.rangeData[index].selected = "";
                });
                user.selected = "selected";
                $scope.toChooseRangeUser = user;
            } else if (type == "toChoose2") {
                angular.forEach($scope.data.selectedPerson, function(data, index, array) {
                    $scope.data.selectedPerson[index].selected = "";
                });
                user.selected = "selected";
                $scope.cancelChooseRangeUser = user;
            }
        };
        $scope.showToggle = function(node) {
            childrenTree(node, function() {});
        };

        function childrenTree(node, callback) {
            if (node.HASCHILDREN == "true" && node.CHILDREN.length === 0) {
                var paramsT = {
                    "serviceid": "mlf_group",
                    "methodname": "queryChildGroupsWithOutRight",
                    "GroupId": node.GROUPID
                };
                trsHttpService.httpServer("/wcm/mlfcenter.do", paramsT, "get").then(function(dataC) {
                    node.CHILDREN = dataC.CHILDREN;
                    callback();
                });
            }
        }
        /** [toRightRange description] 选择按钮将选中的加入到选择列表 */
        $scope.toRight = function() {
            toRight($scope.toChooseRangeUser);
        };
        /** [directlyToRightRange description]双击选中 */
        $scope.directlyToRight = function(user) {
            toRight(user);
        };
        /** [directlyToLeftRange description]双击选中效果 */
        $scope.directlyToLeft = function(item) {
            toLeft(item);
        };
        /** [toRightRange description] 选择按钮将选中的加入到选择列表 */
        $scope.toLeft = function() {
            toLeft($scope.cancelChooseRangeUser);
        };
        /** [showSelected description]:审批人的树节点选择操作 */
        $scope.showSelected = function(node) {
            $scope.toChooseRangeUser = "";
            getGroupData(node);
        };
        /** [toRight description]可见范围的右移假如选中裂变 1*/
        function toRight(item) {
            if (!!item) {
                item = angular.copy(item);
                item.selected = "";
                item.USERNAME = item.TRUENAME;
                var flag = true;
                angular.forEach($scope.data.selectedPerson, function(data, index, array) {
                    if (data.id === item.ID) {
                        flag = false;
                    }
                });
                if (flag) {
                    $scope.data.selectedPerson.push({ name: item.USERNAME, id: item.ID });
                }
            }
        }
        /** [toLeft description]选中列表中的选中移除 */
        function toLeft(item) {
            if (item !== "" && item !== undefined && $scope.data.selectedPerson.indexOf(item) !== -1) {
                $scope.data.selectedPerson.splice($scope.data.selectedPerson.indexOf(item), 1);
            }
        }
        $scope.selectedAll = function() {
            angular.forEach($scope.userDatas, function(data, index, array) {
                delete data.selected;
                var flag = true;
                for (var i in $scope.data.selectedPerson) {
                    if ($scope.data.selectedPerson[i].id === data.ID) {
                        flag = false;
                    }
                }
                if (flag) {
                    $scope.data.selectedPerson.push({ name: data.TRUENAME, id: data.ID });
                }
            });
        };

        function init() {
            //组织树配置文件
            $scope.treePAOptions = {
                nodeChildren: "CHILDREN",
                dirSelectable: true,
                allowDeselect: false,
                injectClasses: {
                    ul: "a1",
                    li: "a2",
                    liSelected: "a7",
                    iExpanded: "a3",
                    iCollapsed: "a4",
                    iLeaf: "a5",
                    label: "a6",
                    labelSelected: "a8"
                },
                isLeaf: function(node) {
                    return node.HASCHILDREN == "false";
                },
            };
            // $scope.expandedPA = angular.copy($scope.expandedTest);
            // $scope.isexpanded = false;
            var treeParams = {
                "serviceid": "mlf_group",
                "methodname": "queryGroupTreeWithMyPath"
            };
            //获取没有权限的组织树
            trsHttpService.httpServer("/wcm/mlfcenter.do", treeParams, "get").then(function(data) {
                $scope.treedataPA = [data];
                ExpandedNodes();
            }, function(data) {});
            //初始化最近记录限制
            $scope.limitRecordNum = 10;
            //初始化可见范围选择列表
            $scope.rangeUserList = [];
        }
        /** [ExpandedNodes description] 加载树 */
        function ExpandedNodes() {
            $scope.expandedPA = [];
            var flag = true;
            $scope.expandedPA.push($scope.treedataPA[0]);
            angular.forEach($scope.treedataPA[0].CHILDREN, function(data, index, array) {
                if (data.ISPATH === "true") {
                    flag = false;
                    if (angular.isDefined(data.CHILDREN) && data.CHILDREN.length !== 0) {
                        $scope.expandedPA.push(data);
                        selfPath(data);
                    } else {
                        $scope.selectedNodePK = data;
                        getGroupData($scope.selectedNodePK);
                    }
                }
            });
            if (flag) {
                $scope.selectedNodePK = $scope.treedataPA[0];
                getGroupData($scope.selectedNodePK);
            }
        }
        /** [getGroupData description] */
        function getGroupData(node) {
            $timeout(function() {
                    //此判断如果两次点击同一个树，不重复加载角色列表。
                    $scope.groupObj = node;
                    $scope.oldSelectNode = node;
                    $scope.Datas = [];
                    $scope.userData = null;
                    var params = {
                        "serviceid": "mlf_group",
                        "methodname": "getUsersByGroup",
                        "GroupId": $scope.groupObj.GROUPID
                    };
                    //trsHttpService.httpServer("./manageConfig/data/roledata_" + $scope.groupObj.id + ".json", params, "get").then(function(data) {
                    trsHttpService.httpServer(trsHttpService.getWCMRootUrl(), params, "get").then(function(data) {
                        $scope.userDatas = data.map(function(user) {
                            return {
                                COMPANY: user.DEPT,
                                DEPT: user.DEPT,
                                ID: user.ID,
                                SUGGESTION: user.SUGGESTION,
                                TRUENAME: user.USERNAME,
                                USERID: user.ID
                            };
                        });
                        $scope.rangeData = $scope.userDatas;
                    }, function(data) {
                        modalDialog.alertType("错误提示", "获取子组失败", "warning", false, function() {});
                    });
                },
                100);
        }
        /** [selfPath description]循环的选中所在的人资 */
        function selfPath(data) {
            for (var i = 0; i < data.CHILDREN.length; i++) {
                if (data.CHILDREN[i].ISPATH === "true") {
                    if (data.CHILDREN[i].HASCHILDREN === "false" || data.CHILDREN[i].CHILDREN.length === 0) {
                        $scope.selectedNodePA = data.CHILDREN[i];
                        getGroupData($scope.selectedNodePA);
                        break;
                    } else {
                        $scope.expandedPA.push(data.CHILDREN[i]);
                        selfPath(data.CHILDREN[i]);
                        break;
                    }
                }
            }
        }
    }
]);